import relations from '../../api/relations';

export default (state = relations.phoneNumber.emptyResponse, action) => {
	switch (action.type) {
		case 'RELATIONS_PHONE_NUMBER_SET':
			return Object.assign({}, state, { phone_number: action.value });
		case 'RELATIONS_PHONE_NUMBER_DATA':
			return action.data;
		default:
			return state;
	}
};

export const action = {
	set: value => ({ type: 'RELATIONS_PHONE_NUMBER_SET', value }),
	data: data => ({ type: 'RELATIONS_PHONE_NUMBER_DATA', data }),
};
